<template>
  <div class="chat-report-container">
    <a-card :bordered="false">
      <!-- 搜索栏 -->
      <div class="table-search-wrapper">
        <a-form layout="inline" :model="searchForm">
          <a-form-item label="处理状态">
            <a-select v-model="searchForm.processStatus" placeholder="全部" allow-clear style="width: 140px">
              <a-select-option :value="1">待处理</a-select-option>
              <a-select-option :value="2">已处理</a-select-option>
              <a-select-option :value="3">误报</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="举报原因">
            <a-select v-model="searchForm.reasonCode" placeholder="全部" allow-clear style="width: 140px">
              <a-select-option :value="1">色情低俗</a-select-option>
              <a-select-option :value="2">骚扰谩骂</a-select-option>
              <a-select-option :value="3">欺诈赌博</a-select-option>
              <a-select-option :value="4">政治敏感</a-select-option>
              <a-select-option :value="5">其他</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="举报人ID">
            <a-input v-model="searchForm.reporterUserId" placeholder="请输入" style="width: 140px" />
          </a-form-item>
          <a-form-item label="被举报人ID">
            <a-input v-model="searchForm.reportedUserId" placeholder="请输入" style="width: 140px" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>

      <!-- 表格 -->
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        row-key="id"
        @change="handleTableChange"
      >
        <template #reasonCode="text">
          <a-tag v-if="text === 1" color="red">色情低俗</a-tag>
          <a-tag v-else-if="text === 2" color="orange">骚扰谩骂</a-tag>
          <a-tag v-else-if="text === 3" color="volcano">欺诈赌博</a-tag>
          <a-tag v-else-if="text === 4" color="purple">政治敏感</a-tag>
          <a-tag v-else>其他</a-tag>
        </template>
        <template #processStatus="text">
          <a-badge v-if="text === 1" status="processing" text="待处理" />
          <a-badge v-else-if="text === 2" status="success" text="已处理" />
          <a-badge v-else-if="text === 3" status="default" text="误报" />
        </template>
        <!-- <template #msgContent="text">
          <span class="msg-content-ellipsis">{{ text || '-' }}</span>
        </template> -->
        <template #action="record">
          <a-space>
            <a @click="showDetail(record)">详情</a>
            <a v-if="record.processStatus === 1" @click="showHandle(record)">处理</a>
            <a-popconfirm
              title="确认删除该举报记录？"
              @confirm="handleDelete(record)"
            >
              <a style="color: #ff4d4f">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>

    <!-- 详情弹窗 -->
    <a-modal
      v-model="detailVisible"
      title="举报详情"
      width="700px"
      :footer="null"
    >
      <a-descriptions v-if="detailData" :column="2" bordered size="small">
        <a-descriptions-item label="举报ID">{{ detailData.id }}</a-descriptions-item>
        <a-descriptions-item label="会话类型">{{ detailData.conversationType }}</a-descriptions-item>
        <a-descriptions-item label="举报人">{{ detailData.reporterNickName || detailData.reporterUserId }}</a-descriptions-item>
        <a-descriptions-item label="被举报人">{{ detailData.reportedNickName || detailData.reportedUserId }}</a-descriptions-item>
        <a-descriptions-item label="消息时间">{{ formatTime(detailData.msgTime) }}</a-descriptions-item>
        <a-descriptions-item label="举报时间">{{ formatTime(detailData.createTime) }}</a-descriptions-item>
        <a-descriptions-item label="举报原因">
          <a-tag v-if="detailData.reasonCode === 1" color="red">色情低俗</a-tag>
          <a-tag v-else-if="detailData.reasonCode === 2" color="orange">骚扰谩骂</a-tag>
          <a-tag v-else-if="detailData.reasonCode === 3" color="volcano">欺诈赌博</a-tag>
          <a-tag v-else-if="detailData.reasonCode === 4" color="purple">政治敏感</a-tag>
          <a-tag v-else>其他</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="消息Seq">{{ detailData.msgSeq || '-' }}</a-descriptions-item>
        <!-- <a-descriptions-item label="消息内容" :span="2">{{ detailData.msgContent || '-' }}</a-descriptions-item> -->
        <a-descriptions-item label="举报描述" :span="2">{{ detailData.description || '-' }}</a-descriptions-item>
        <a-descriptions-item label="处理状态">
          <a-badge v-if="detailData.processStatus === 1" status="processing" text="待处理" />
          <a-badge v-else-if="detailData.processStatus === 2" status="success" text="已处理" />
          <a-badge v-else-if="detailData.processStatus === 3" status="default" text="误报" />
        </a-descriptions-item>
        <a-descriptions-item label="处理人">{{ detailData.processBy || '-' }}</a-descriptions-item>
        <a-descriptions-item label="处置方式">{{ detailData.disposalAction || '-' }}</a-descriptions-item>
        <a-descriptions-item label="处置结果">{{ detailData.disposalResult || '-' }}</a-descriptions-item>
        <a-descriptions-item label="处理备注" :span="2">{{ detailData.processResult || '-' }}</a-descriptions-item>
        <a-descriptions-item label="截图证据" :span="2">
          <div v-if="detailData.evidenceImages" class="evidence-images">
            <img
              v-for="(url, idx) in getEvidenceUrls(detailData.evidenceImages)"
              :key="idx"
              :src="url"
              class="evidence-img"
              @click="previewImage(url)"
            />
          </div>
          <span v-else>-</span>
        </a-descriptions-item>
      </a-descriptions>
      <!-- 上下文消息 -->
      <a-divider>上下文消息</a-divider>
      <a-spin :spinning="contextLoading">
        <div v-if="contextMessages.length > 0" class="context-messages">
          <div
            v-for="(msg, idx) in contextMessages"
            :key="idx"
            class="context-msg-item"
            :class="{ 'is-reported': msg.msgSeq === detailData.msgSeq }"
          >
            <span class="msg-sender">{{ msg.fromUserId }}:</span>
            <span class="msg-body">{{ formatMsgBody(msg.msgBody) }}</span>
          </div>
        </div>
        <a-empty v-else description="无法拉取上下文消息" />
      </a-spin>
    </a-modal>

    <!-- 处理弹窗 -->
    <a-modal
      v-model="handleVisible"
      title="处理举报"
      width="500px"
      @ok="submitHandle"
      :confirm-loading="handleLoading"
    >
      <a-form :model="handleForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="处理状态" required>
          <a-radio-group v-model="handleForm.processStatus">
            <a-radio :value="2">已处理</a-radio>
            <a-radio :value="3">误报</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="处置方式">
          <a-select v-model="handleForm.disposalAction" placeholder="无需处置" allow-clear style="width: 100%">
            <a-select-option value="DELETE_MSG">删除消息</a-select-option>
            <a-select-option value="MUTE">禁言用户</a-select-option>
            <a-select-option value="BAN">封禁用户</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="handleForm.disposalAction === 'MUTE'" label="禁言时长">
          <a-input-number
            v-model="handleForm.muteSeconds"
            :min="60"
            placeholder="秒，默认永久禁言"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="处理备注">
          <a-textarea
            v-model="handleForm.processResult"
            :rows="3"
            placeholder="请输入处理备注"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { page, detail, process, contextMessages, del } from '@/api/app/chat-report'

export default {
  name: 'ChatReport',
  data() {
    return {
      searchForm: {
        processStatus: undefined,
        reasonCode: undefined,
        reporterUserId: '',
        reportedUserId: '',
      },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '举报人', dataIndex: 'reporterNickName', width: 100, customRender: (text, record) => text || record.reporterUserId },
        { title: '被举报人', dataIndex: 'reportedNickName', width: 100, customRender: (text, record) => text || record.reportedUserId },
        // { title: '消息内容', dataIndex: 'msgContent', scopedSlots: { customRender: 'msgContent' }, ellipsis: true },
        { title: '举报原因', dataIndex: 'reasonCode', scopedSlots: { customRender: 'reasonCode' }, width: 100 },
        { title: '状态', dataIndex: 'processStatus', scopedSlots: { customRender: 'processStatus' }, width: 100 },
        { title: '举报时间', dataIndex: 'createTime', width: 160, customRender: (text) => this.formatTime(text) },
        { title: '操作', scopedSlots: { customRender: 'action' }, width: 160, fixed: 'right' },
      ],
      dataSource: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      // 详情
      detailVisible: false,
      detailData: null,
      contextMessages: [],
      contextLoading: false,
      // 处理
      handleVisible: false,
      handleLoading: false,
      handleForm: {
        id: null,
        processStatus: 2,
        disposalAction: undefined,
        muteSeconds: undefined,
        processResult: '',
      },
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.searchForm,
        }
        const res = await page(params)
        if (res?.data) {
          this.dataSource = res.data.records || []
          this.pagination.total = res.data.total || 0
        }
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchList()
    },
    handleReset() {
      this.searchForm = {
        processStatus: undefined,
        reasonCode: undefined,
        reporterUserId: '',
        reportedUserId: '',
      }
      this.pagination.current = 1
      this.fetchList()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchList()
    },
    async showDetail(record) {
      this.detailVisible = true
      this.contextMessages = []
      const res = await detail(record.id)
      if (res?.data) {
        this.detailData = res.data
      }
      // 拉取上下文消息
      this.contextLoading = true
      try {
        const ctxRes = await contextMessages(record.id)
        if (ctxRes?.data) {
          this.contextMessages = ctxRes.data
        }
      } finally {
        this.contextLoading = false
      }
    },
    showHandle(record) {
      this.handleForm = {
        id: record.id,
        processStatus: 2,
        disposalAction: undefined,
        muteSeconds: undefined,
        processResult: '',
      }
      this.handleVisible = true
    },
    async submitHandle() {
      this.handleLoading = true
      try {
        await process(this.handleForm)
        this.$message.success('处理成功')
        this.handleVisible = false
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '处理失败')
      } finally {
        this.handleLoading = false
      }
    },
    async handleDelete(record) {
      try {
        await del(record.id)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    },
    formatTime(timestamp) {
      if (!timestamp && timestamp !== 0) return '-'
      let d
      if (typeof timestamp === 'string') {
        // 纯数字字符串 = Unix 时间戳（秒）
        if (/^\d+$/.test(timestamp)) {
          d = new Date(Number(timestamp) * 1000)
        } else {
          // 兼容后端 yyyy-MM-dd HH:mm:ss 格式和 ISO 格式
          d = new Date(timestamp.replace(' ', 'T'))
        }
      } else if (typeof timestamp === 'number') {
        d = new Date(timestamp * 1000)
      } else {
        return '-'
      }
      if (isNaN(d.getTime())) return '-'
      return d.toLocaleString()
    },
    getEvidenceUrls(images) {
      if (!images) return []
      return images.split(',').filter(Boolean)
    },
    previewImage(url) {
      // 简单预览
      window.open(url, '_blank')
    },
    formatMsgBody(msgBody) {
      if (!msgBody || msgBody.length === 0) return '[空]'
      try {
        const item = msgBody[0]
        if (item.msgContent && item.msgContent.text) {
          return item.msgContent.text
        }
        return JSON.stringify(item).substring(0, 200)
      } catch (e) {
        return '[解析失败]'
      }
    },
  },
}
</script>

<style lang="less" scoped>
.chat-report-container {
  padding: 16px;
}

.table-search-wrapper {
  margin-bottom: 16px;
}

.msg-content-ellipsis {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .evidence-img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #e8e8e8;
  }
}

.context-messages {
  max-height: 300px;
  overflow-y: auto;
  background: #fafafa;
  border-radius: 4px;
  padding: 12px;

  .context-msg-item {
    padding: 4px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;

    &:last-child {
      border-bottom: none;
    }

    &.is-reported {
      background: #fff2f0;
      padding: 8px;
      border-radius: 4px;
      margin: 4px 0;
      border: 1px solid #ffccc7;
    }

    .msg-sender {
      color: #1677ff;
      margin-right: 8px;
    }

    .msg-body {
      color: #333;
      word-break: break-all;
    }
  }
}
</style>
